// import * as React from "react";
// import { useEffect, useState } from "react";
// import { fetchData } from "../../Cpanel/Components/Utilities";
// import Helmet from "../Components/Helment";
// import { TabPanel, TabView } from "primereact/tabview";
// import { OnlineShops } from "../Components/Shops/OnlineShops";
// import { FilterSidebar } from "../Components/Shops/FilterSidebar";
// import { LocalShops } from "../Components/Shops/LocalShops";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Paginator } from "primereact/paginator";

// const Shops = () => {
//   const [shopData, setShopData] = useState([]);
//   const [onlineShops, setOnlineShops] = useState([]);
//   const [localShops, setLocalShops] = useState([]);
//   const [activeTab, setActiveTab] = useState(0); // 'online' or 'local'

//   useEffect(() => {
//     const onlinebodyFormData = new FormData();
//     onlinebodyFormData.append("type", 1);
//     const offlinebodyFormData = new FormData();
//     offlinebodyFormData.append("type", 2);
//     fetchData("shoplist", onlinebodyFormData, handleOnlineApiResponse);
//     fetchData("shoplist", offlinebodyFormData, handleOfflineApiResponse);
//   }, []);
//   const handleOnlineApiResponse = (data) => {
//     setOnlineShops(data);
//   };
//   const handleOfflineApiResponse = (data) => {
//     setLocalShops(data);
//   };
//   const handleTabChange = (event) => {
//     setActiveTab(event.index); // Update active tab
//   };
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };
//   const [first, setFirst] = useState(0);
//   const [rows, setRows] = useState(10);

//   const onPageChange = (event) => {
//     setFirst(event.first);
//     setRows(event.rows);
//   };
//   return (
//     <Helmet title="فروشگاه ها">
//       <div
//         className={
//           isSidebarOpen
//             ? "d-none"
//             : "d-flex d-md-none justify-content-start gap-1 p-2 bg-white rounded w-75 mx-5"
//         }
//         onClick={toggleSidebar}
//       >
//         <FontAwesomeIcon
//           icon={"filter-circle-xmark"}
//           className="fs-5 text-primary"
//         />
//         <div>فیلتر ها</div>
//       </div>

//       <div className="d-flex mb-3 h-auto" id="wrapper">
//         <FilterSidebar
//           activeTab={activeTab === 0 ? "online" : "local"}
//           shopList={activeTab === 0 ? onlineShops : localShops}
//           className={isSidebarOpen ? "filter-sidebar open" : "filter-sidebar"}
//           onCloseFilterMobile={toggleSidebar}
//         />
//         <div id="content" className="container-fluid overflow-scroll">
//           <div className="bg-white p-2 w-100 mb-3">banner</div>
//           <div>

//             <TabView
//               dir="rtl"
//               className=" tab-header"
//               activeIndex={activeTab}
//               onTabChange={handleTabChange}
//             >
//               <div className="bg-primary p-2 m-2">swipper</div>
//               <TabPanel header="فروشگاه های آنلاین" className="tab-title  ">
//                 <OnlineShops
//                   shopList={onlineShops}
//                   className="shop-card-container"
//                 />
//               </TabPanel>
//               <TabPanel header="فروشگاه های حضوری" className="tab-title ">
//                 <LocalShops shopList={localShops} />
//               </TabPanel>
//             </TabView>
//           </div>
//           <div className="">
//             <Paginator
//               first={first}
//               rows={rows}
//               totalRecords={onlineShops?.dt?.length}
//               rowsPerPageOptions={[10, 15, 20]}
//               onPageChange={onPageChange}
//             />
//           </div>
//         </div>
//       </div>
//     </Helmet>
//   );
// };

// export default Shops;

// import * as React from "react";
// import { useEffect, useState } from "react";
// import { fetchData } from "../../Cpanel/Components/Utilities";
// import Helmet from "../Components/Helment";
// import { OnlineShops } from "../Components/Shops/OnlineShops";
// import { LocalShops } from "../Components/Shops/LocalShops";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Paginator } from "primereact/paginator";

// const Shops = () => {
//   const [shopData, setShopData] = useState([]);
//   const [onlineShops, setOnlineShops] = useState([]);
//   const [localShops, setLocalShops] = useState([]);
//   const [activeTab, setActiveTab] = useState("online"); // 'online' or 'local'

//   useEffect(() => {
//     const onlinebodyFormData = new FormData();
//     onlinebodyFormData.append("type", 1);
//     const offlinebodyFormData = new FormData();
//     offlinebodyFormData.append("type", 2);
//     fetchData("shoplist", onlinebodyFormData, handleOnlineApiResponse);
//     fetchData("shoplist", offlinebodyFormData, handleOfflineApiResponse);
//   }, []);

//   const handleOnlineApiResponse = (data) => {
//     setOnlineShops(data);
//   };

//   const handleOfflineApiResponse = (data) => {
//     setLocalShops(data);
//   };

//   const handleTabChange = (tab) => {
//     setActiveTab(tab); // Update active tab
//   };

//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   const [first, setFirst] = useState(0);
//   const [rows, setRows] = useState(10);

//   const onPageChange = (event) => {
//     setFirst(event.first);
//     setRows(event.rows);
//   };

//   return (
//     <Helmet title="فروشگاه ها">
//       <div
//         className={
//           isSidebarOpen
//             ? "d-none"
//             : "d-flex d-md-none justify-content-start gap-1 p-2 bg-white rounded w-75 mx-5"
//         }
//         onClick={toggleSidebar}
//       >
//         <FontAwesomeIcon
//           icon={"filter-circle-xmark"}
//           className="fs-5 text-primary"
//         />
//         <div>فیلتر ها</div>
//       </div>

//       <div className="d-flex mb-3 h-auto" id="wrapper">
//       <FilterSidebar
//           activeTab={activeTab === 0 ? "online" : "local"}
//           shopList={activeTab === 0 ? onlineShops : localShops}
//           className={isSidebarOpen ? "filter-sidebar open" : "filter-sidebar"}
//           onCloseFilterMobile={toggleSidebar}
//         />
//         <div className="container-fluid overflow-scroll">
//           <div className="bg-white p-2 w-100 mb-3">banner</div>
//           <div className="bg-primary p-2 m-2">swipper</div>
//           <div className="d-flex justify-content-center mb-2">
//             <button
//               className={`btn ${
//                 activeTab === "online" ? "btn-primary" : "btn-secondary"
//               }`}
//               onClick={() => handleTabChange("online")}
//             >
//               فروشگاه های آنلاین
//             </button>
//             <button
//               className={`btn ${
//                 activeTab === "local" ? "btn-primary" : "btn-secondary"
//               }`}
//               onClick={() => handleTabChange("local")}
//             >
//               فروشگاه های حضوری
//             </button>
//           </div>
//           {activeTab === "online" && (
//             <OnlineShops
//               shopList={onlineShops}
//               className="shop-card-container"
//             />
//           )}
//           {activeTab === "local" && <LocalShops shopList={localShops} />}
//           <div className="d-flex justify-content-center">
//             <Paginator
//               first={first}
//               rows={rows}
//               totalRecords={onlineShops?.dt?.length}
//               rowsPerPageOptions={[10, 15, 20]}
//               onPageChange={onPageChange}
//             />
//           </div>
//         </div>
//       </div>
//     </Helmet>
//   );
// };

// export default Shops;

import * as React from "react";
import { useEffect, useState } from "react";
import { fetchData } from "../../Cpanel/Components/Utilities";
import Helmet from "../Components/Helment";
import { OnlineShops } from "../Components/Shops/OnlineShops";
import { LocalShops } from "../Components/Shops/LocalShops";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Paginator } from "primereact/paginator";
import { FilterSidebar } from "../Components/Shops/FilterSidebar";
import { Carousel } from "primereact/carousel";
import { Tag } from "primereact/tag";
import { Button } from "react-bootstrap";
import Slider from "react-slick";
import Cat1 from "../../Assets/images/563715630260656128.png";
const Shops = () => {
  const [shopData, setShopData] = useState([]);
  const [onlineShops, setOnlineShops] = useState([]);
  const [localShops, setLocalShops] = useState([]);
  const [activeTab, setActiveTab] = useState("online"); // 'online' or 'local'
  const [products, setProducts] = useState([]);
  useEffect(() => {
    const onlinebodyFormData = new FormData();
    onlinebodyFormData.append("type", 1);
    const offlinebodyFormData = new FormData();
    offlinebodyFormData.append("type", 2);
    fetchData("shoplist", onlinebodyFormData, handleOnlineApiResponse);
    fetchData("shoplist", offlinebodyFormData, handleOfflineApiResponse);
    handleProductsResponse([
      { id: 1, name: "نان وغلات", img: Cat1 },
      { id: 1, name: "نان وغلات", img: Cat1 },
      { id: 1, name: "نان وغلات", img: Cat1 },
      { id: 1, name: "نان وغلات", img: Cat1 },
      { id: 1, name: "نان وغلات", img: Cat1 },
      { id: 1, name: "نان وغلات", img: Cat1 },
      { id: 1, name: "نان وغلات", img: Cat1 },
    ]);
  }, []);

  const handleOnlineApiResponse = (data) => {
    setOnlineShops(data);
  };

  const handleOfflineApiResponse = (data) => {
    setLocalShops(data);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab); // Update active tab
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const handleProductsResponse = (data) => {
    setProducts(data);
  };

  // Render function for each product item in the carousel
  // const renderCategory = (product) => {
  //   return (
  //     <div key={product.id} className="p-d-flex p-ai-center p-jc-center">
  //       <img src={product.image} alt={product.name} className="product-image" />
  //       <div className="product-name">{product.name}</div>
  //     </div>
  //   );
  // };

  console.log(onlineShops);
  const renderCategory = (product) => {
    // Filter online or local shops based on the selected category
    const filteredShops =
      activeTab === "online"
        ? onlineShops?.dt?.filter((shop) => shop?.category === product?.name)
        : localShops?.dt?.filter((shop) => shop?.category === product?.name);

    return (
      <div key={product.id} className="category-item ">
        <div className="category-wrapper">
          <img
            src={product.img}
            alt={product.name}
            className="category-icon"
          />
        <div className=" category-name">{product.name}</div>
        {/* Display the number of shops in the category */}
        {/* <div>{filteredShops?.length} shops</div> */}
        </div>
      </div>
    );
  };

  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 6.5,
    slidesToScroll: 3.5,
    swipeToSlide: true,
    // autoplay: true, // Enable autoplay
    // autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          // dots: true
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2,
        },
      },
    ],
  };
  const sliderRef = React.useRef();

  // const goToNext = () => {
  //   sliderRef.current.slickNext();
  // };

  // const goToPrev = () => {
  //   sliderRef.current.slickPrev();
  // };

  return (
    <Helmet title="فروشگاه ها">
      <div className="d-flex mb-3 h-auto" id="wrapper">
        <FilterSidebar
          activeTab={activeTab === "online" ? "online" : "local"}
          shopList={activeTab === "online" ? onlineShops : localShops}
          className={isSidebarOpen ? "filter-sidebar open" : "filter-sidebar"}
          onCloseFilterMobile={toggleSidebar}
        />
        <div id="content" className="container-fluid overflow-scroll">
          <div
            className={
              isSidebarOpen
                ? "d-none"
                : "d-flex d-md-none justify-content-start gap-1 p-2 bg-white rounded w-75 mx-5"
            }
            onClick={toggleSidebar}
          >
            <FontAwesomeIcon
              icon={"filter-circle-xmark"}
              className="fs-5 text-primary"
            />
            <div>فیلتر ها</div>
          </div>
          {/* <div className="bg-light p-2 w-100 mb-3">banner</div> */}
          <div className="d-flex justify-content-center mb-2 gap-2">
            <button
              className={`btn ${
                activeTab === "online"
                  ? "btn-primary"
                  : "btn-secondary disabled-btn"
              }`}
              onClick={() => handleTabChange("online")}
            >
              فروشگاه های آنلاین
            </button>
            <button
              className={`btn ${
                activeTab === "local"
                  ? "btn-primary"
                  : "btn-secondary disabled-btn"
              }`}
              onClick={() => handleTabChange("local")}
            >
              فروشگاه های حضوری
            </button>
          </div>
          <div className="card p-2 bg-light">
            <Slider ref={sliderRef} {...settings}>
              {products.map((category) => renderCategory(category))}
            </Slider>
          </div>
          {/* <div className="d-flex justify-content-between">
            <button onClick={() => sliderRef.current?.slickPrev()}>Previous</button>
            <button onClick={() => sliderRef.current?.slickNext()}>Next</button>
          </div> */}

          {activeTab === "online" && (
            <OnlineShops
              shopList={onlineShops}
              className="shop-card-container"
            />
          )}
          {activeTab === "local" && <LocalShops shopList={localShops} />}
          <div className="d-flex justify-content-center">
            <Paginator
              first={first}
              rows={rows}
              totalRecords={onlineShops?.dt?.length}
              rowsPerPageOptions={[10, 15, 20]}
              onPageChange={onPageChange}
            />
          </div>
        </div>
      </div>
    </Helmet>
  );
};

export default Shops;
